import 'jquery.scrollbar/jquery.scrollbar.min.js'
import '../fesd/library/delay4.js'
import '../fesd/plugin/video4.js'

export const ajax = {
  //打開Ajax
  openAjax(route, container, callback){
    $.ajax4({
      Route: route,
      Container: container,
      Block: '',
      Callback: callback,
      Backready: '',
      Backloaded: '',
    });
  },
  //關閉Ajax
  closeAjax(container){
    $(container).removeClass('show')
    _common.scrollUnlock()
    $(container).on('transitionend webkitTransitionEnd oTransitionEnd', function () {
      //ajax關掉之後要做的事寫在這
      //....
      $(container).remove()
      $(container).unbind('transitionend webkitTransitionEnd oTransitionEnd')
    })
  },
  //ajax共用
  ajaxCommon(data) {
    const container = data.Container
    if(!$(container).find('[data-box-name]').hasClass('outer-locked')) {
      $(container).addClass('ajax_close')
    }
    $(container).delay4({ time: '100', add: 'show' })
    $(container).find('.modal-scroll-wrap').scrollbar({
      ignoreMobile: true,
    })
    $(container).find('.modal-dialog').on('click',function(e){
      e.stopPropagation()
    })
    $('.ajax_close').on('click', function (e) {
      e.stopPropagation()
      ajax.closeAjax(container)
    })
    _common.scrollLock()
  },
}

export const ajaxCallback = {
  //一般燈箱
  normalLightbox(data) {
    ajax.ajaxCommon(data)
    $('[video-id]').video4();
    $('[data-anchor4]').anchor4();
    $('[data-anchor4]').on('click', (e) => {
      e.stopPropagation();
    });

  }
}